// extracted by mini-css-extract-plugin
export default {"root":"ProductBadgesList_root__b9gXW","btn":"ProductBadgesList_btn__7jACR"};